import React from 'react';
import { connect, useDispatch } from 'react-redux';
import { setPopUp } from 'actions/environment';
import { withTranslation } from 'react-i18next';
import { updateProfileRegion } from 'actions/profile';
import { allNews, nedvexNews, favoritesNews } from 'actions/news';
import { gaEvent, trackGA } from 'services/ga';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { resetObjects } from 'actions/objects';
import RegionAccordion from '../RegionAccordion';
import { saveSelectedRegions } from 'utils/regionStorage';

const RegionPopup = ({
  cities: citiesProp,
  profile,
  updateProfileRegion: updateProfileRegionProp,
  setPopUp: setPopUpProp,
  location,
  isCurrentBuildingTypeIsCottage,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const handleSelectRegionClick = async (cities) => {
    const citiesArray = Array.isArray(cities) ? cities : [cities];

    const firstCity = citiesArray[0];
    trackGA(
      gaEvent.locationDialogButtonsClick({
        eventContent: [firstCity.country.name, firstCity.name],
        user_id: profile.id,
      })
    );

    try {
      saveSelectedRegions(citiesArray);

      const updatedProfile = { ...profile };

      if (citiesArray.length === 1) {
        updatedProfile.cityId = citiesArray[0].id;
        updatedProfile.user_region = {
          city: citiesArray[0].name,
          country_id: citiesArray[0].country.id,
          country_name: citiesArray[0].country.name,
          country_currency: citiesArray[0].country.currency || 'RUB',
          country_currency_symbol: citiesArray[0].country.currency_symbol || '₽',
        };
      }

      updatedProfile.user_regions = citiesArray.map((city) => ({
        city: city.name,
        country_id: city.country.id,
        country_name: city.country.name,
        country_currency: city.country.currency || 'RUB',
        country_currency_symbol: city.country.currency_symbol || '₽',
      }));

      updatedProfile.cities = citiesArray.map((city) => city.id);

      await updateProfileRegionProp(updatedProfile);

      dispatch(resetObjects());

      setPopUpProp();

      if (location.pathname.match(/building/)) {
        if (isCurrentBuildingTypeIsCottage) {
          history.push('/cottages');
        } else {
          history.push('/');
        }
      } else {
        await dispatch(allNews({ limit: 20, offset: 0 }));
        await dispatch(nedvexNews({ limit: 20, offset: 0 }));
        await dispatch(favoritesNews({ limit: 20, offset: 0 }));
      }
    } catch (error) {
      console.error(error);
      setPopUpProp();
    }
  };

  const handleClose = () => {
    setPopUpProp();
  };

  return (
    <div style={{ width: '53rem' }}>
      <RegionAccordion
        cities={citiesProp}
        profile={profile}
        onSave={handleSelectRegionClick}
        onClose={handleClose}
      />
    </div>
  );
};

export default connect(
  (state) => ({
    userUid: state.profile.hash,
  }),
  { setPopUp, updateProfileRegion }
)(withTranslation()(RegionPopup));



// WEBPACK FOOTER //
// ./src/components/Header/Region/RegionPopup/RegionPopup.js